import {Inject, Injectable} from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import {apiEndpoints} from '@user/config/global-vars';

@Injectable({ providedIn: 'root' })
export class LoggingService {
  private httpWithoutInterceptor: HttpClient;
  baseDomain = '';
  apiUrl = '';

  constructor(@Inject('env') private env: any,private handler: HttpBackend) {
    this.httpWithoutInterceptor = new HttpClient(handler);
    this.apiUrl = `${this.baseDomain}${this.env?.apiRoute}`;
  }

  logError(payload: any) {
    let url = this.apiUrl + apiEndpoints.log_error;
    return this.httpWithoutInterceptor.post(url, payload);
  }
}
